import React from 'react';
import { Text, StyleSheet, Image, View } from '@react-pdf/renderer';

type Props = {
  dailyHeatmap: string;
  detailedHeatmap: string;
  fourthPageDailyHeatmapText: string;
  fourthPageDetailedHeatmapText: JSX.Element;
};

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    color: '#4E73C3',
    marginBottom: 16,
  },
  paragraph: {
    color: '#000',
    lineHeight: 1.5,
    letterSpacing: -0.32,
  },
});

const FourthPage = ({
  dailyHeatmap,
  detailedHeatmap,
  fourthPageDailyHeatmapText,
  fourthPageDetailedHeatmapText,
}: Props) => {
  return (
    <View>
      <Text style={styles.title}>
        What days were the worst for air quality?
      </Text>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: 499,
          width: 499,
          maxHeight: 174,
          height: 174,
          marginBottom: 32,
        }}
      >
        <View style={{ width: 188, fontSize: 11, marginRight: 16 }}>
          <Text style={{ ...styles.paragraph, marginBottom: 20 }}>
            The worst day this month experienced{' '}
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>
              {fourthPageDailyHeatmapText}
            </Text>{' '}
            air quality.
          </Text>
          <Text style={styles.paragraph}>
            Air quality changes day-to-day and is impacted by a variety of
            things such as traffic and weather. This heatmap helps identify
            specific days where air quality was poorest. The data is based on
            the worst recorded reading of that day.
          </Text>
        </View>
        <View style={{ width: 295 }}>
          <Image style={{ width: 295 }} src={dailyHeatmap} />
        </View>
      </View>
      <View>
        <Text style={styles.title}>
          What pollutants are affecting the air quality?
        </Text>
        <Text style={{ ...styles.paragraph, marginBottom: 16, fontSize: 11 }}>
          Air Quality can be affected by multiple pollutants. This chart helps
          identify the pollutants which are affecting air quality.
        </Text>
        <View style={{ width: 499, marginBottom: 16 }}>
          <Image style={{ width: 499, height: 235 }} src={detailedHeatmap} />
        </View>
        {fourthPageDetailedHeatmapText}
      </View>
    </View>
  );
};

export default FourthPage;
